module.exports = __webpack_public_path__ + "static/frontUserNew/img/code-app.6631400b.png";